// src/stores/maintenanceStore.js
import { defineStore } from 'pinia'
import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import { onSnapshot } from '@/services/sessionListeners'
import { db } from '@/services/firebaseconfig'
import { useUserStore } from '@/stores/userStore'

export const useMaintenanceStore = defineStore('maintenance', {
  state: () => ({
    enabled: false,
    message: 'The site is temporarily down for maintenance. Please check back later.',
    initialized: false,
    _unsub: null,
  }),
  actions: {
    async start() {
      if (this._unsub) return
      // mark initialized immediately so callers don't block
      this.initialized = true

      const ref = doc(db, 'globalSettings', 'default')
      this._unsub = onSnapshot(
        ref,
        snap => {
          const data = snap.exists() ? snap.data() : {}
          const m = data.maintenance || {}
          this.enabled = !!m.enabled
          this.message =
            typeof m.message === 'string' && m.message.trim()
              ? m.message
              : 'The site is temporarily down for maintenance. Please check back later.'
          // initialized already true; no need to set here
        },
        () => {
          // if read fails, keep initialized true; feature degrades gracefully
        }
      )
    },
    stop() {
      this._unsub?.()
      this._unsub = null
      this.initialized = false
    },
    async setMaintenance({ enabled, message }) {
      const userStore = useUserStore()
      const ref = doc(db, 'globalSettings', 'default')
      await setDoc(
        ref,
        {
          maintenance: {
            enabled: !!enabled,
            message: (message ?? '').toString(),
            updatedAt: serverTimestamp(),
            updatedBy: userStore.user?.uid || null,
          },
        },
        { merge: true }
      )
    },
  },
})
